<template>
  <ion-content fullscreen>
    <ion-item class="close-fake" lines="none" text-center>
      <ion-button @click="close" fill="clear" color="light">
        <font-awesome-icon slot="start" icon="times"></font-awesome-icon>
        <span class="m-l-m">Back</span>
      </ion-button>

      <ion-button @click="zoom(true)" fill="clear" color="light">
        <font-awesome-icon slot="start" icon="plus"></font-awesome-icon>
        <span class="m-l-m">In</span>
      </ion-button>

      <ion-button @click="zoom(false)" fill="clear" color="light">
        <font-awesome-icon slot="start" icon="minus"></font-awesome-icon>
        <span class="m-l-m">Out</span>
      </ion-button>
    </ion-item>

    <ion-slides :options.prop="options" ref="slider">
      <ion-slide>
        <div class="swiper-zoom-container">
          <img v-bind:src="image" />
        </div>
      </ion-slide>
    </ion-slides>
  </ion-content>
</template>

<script>
export default {
  name: "ImageModal",
  data() {
    return {
      image: "",
      options: {
        zoom: {
          maxRatio: 3
        }
      }
    };
  },

  methods: {
    zoom(zoomIn) {
      const swiper = document.querySelector(".swiper-container").swiper;
      let zoom = swiper.zoom;

      if (zoomIn) {
        zoom.in();
      } else {
        zoom.out();
      }
    },

    close() {
      return this.$ionic.modalController.dismiss();
    }
  }
};
</script>

<style scoped>
.close-fake {
  --background: transparent;
  margin-top: 40px;
  font-size: 2rem;
}

ion-content {
  --background: var(--ion-color-dark);
}

ion-slides {
  height: 80%;
}
</style>